export class PipeModel {
    name: string = '';
    data: Data[] = [];
}

class Data {
    tagType: string = 'T';
    operator: string = '5';
    operand = new Operand;
    merger?:string = '';
}
class Operand {
    L = new L;
    R = new R;
}

class L {
    type: string = 'Q';
    id: string[] = [];
}

class R {
    type: string = 'C';
    id: string[] = [];
}